export enum BaleBotStatus {
  PendingReviewByAdmin = 1,
  UnderCreationAtMessenger = 2,
  Approved = 3,
  Rejected = 4,
}
